import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseModalContainer ,ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { Posao } from './posao';

@Component({
  selector: 'yt-posao',
  templateUrl: './posao.component.html'
})
export class PosaoComponent extends BaseModalContainer<Posao> {

  constructor(
    protected modalContainerService: ModalContainerService<Posao>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService

  ) {
    super(modalContainerService, activatedRoute, modalService, userService)
   }

  ngOnInit() {
  }

}
